// extracted by mini-css-extract-plugin
module.exports = {"toastr-container":"_3lUE9M","content":"_1Zc8t9","text":"_1V_1yN","title":"_21sk1I","middle-container":"_26uh0K","left-container":"_3Bn6Ue","right-container":"_2hY_bC"};